/* eslint-disable max-len */
import { createReducer, FAILURE, REQUEST, SUCCESS, updateObject } from 'Stores'
import { getLocalStorage, STORAGE } from 'Utils'
import { getCookie } from 'Utils/cookies'
import {
  LOGIN,
  LOGIN_GOOGLE_SSO,
  LOGIN_MS_SSO,
  LOGOUT,
  PAYMENT_REGISTER,
  REGISTER_BASIC,
  REGISTER_BASIC_INVITE,
  REGISTER_ENTERPRISE,
  REGISTER_GOOGLE_SSO,
  REGISTER_RESEND_EMAIL,
  SET_IS_2FA,
  SIGN_UP_VERIFY_TOKEN
} from './constants'

export const initialState = {
  isLoading: false,
  error: null,
  authenticated: getLocalStorage(STORAGE.USER_TOKEN) ? !!getLocalStorage(STORAGE.USER_TOKEN) : !!getCookie(STORAGE.USER_TOKEN),
  metaData: {},
  profile: {
    role: getCookie(STORAGE.ROLE) || getLocalStorage(STORAGE.ROLE)
  },
  isSubmitting: false,
  isEnable2FA: getLocalStorage(STORAGE.FAEnabled) === 'true',
  isCheck2FA: getLocalStorage(STORAGE.IS_CHECK2FA) === 'true'
}

function registerGoogleSSO(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function registerGoogleSSOSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    authenticated: true,
    metaData: {
      type: 'google-sso',
      token: payload.token
    }
  })
}

function registerGoogleSSOError(state, { error }) {
  return updateObject(state, {
    error,
    isLoading: false,
    authenticated: false
  })
}

function registerBasic(state) {
  return updateObject(state, {
    loading: true
  })
}

function registerBasicSuccess(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function registerBasicError(state, { error }) {
  return updateObject(state, {
    error,
    isLoading: false
  })
}

function registerBasicInvite(state) {
  return updateObject(state, {
    loading: true
  })
}

function registerBasicInviteSuccess(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function registerBasicInviteError(state, { error }) {
  return updateObject(state, {
    error,
    isLoading: false
  })
}

function registerWithPayment(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function registerWithPaymentSuccess(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function registerWithPaymentError(state) {
  return updateObject(state, {
    error: FAILURE(PAYMENT_REGISTER),
    isLoading: false
  })
}

function registerReSendEmail(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function registerReSendEmailSuccess(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function registerReSendEmailError(state, { error }) {
  return updateObject(state, {
    error,
    isLoading: false
  })
}

function loadLogin(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function loginSuccess(state, { payload, isCheck2FA }) {
  return updateObject(state, {
    isLoading: false,
    authenticated: true,
    profile: payload,
    isCheck2FA
  })
}

function setIs2FASuccess(state) {
  return updateObject(state, {
    isLoading: false,
    authenticated: true,
    isEnable2FA: true,
    isCheck2FA: true
  })
}

function loginFail(state, { error }) {
  return updateObject(state, {
    error,
    isLoading: false,
    authenticated: false
  })
}

function logOut(state) {
  return updateObject(state, {
    authenticated: false,
    isEnable2FA: false
  })
}

function loadLoginGoogleSSO(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function loadLoginGoogleSSOSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    authenticated: true

  })
}

function loadLoginGoogleSSOFail(state, { error }) {
  return updateObject(state, {
    error,
    isLoading: false,
    authenticated: false
  })
}

function loadLoginMSSSO(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function loadLoginMSSSOSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    authenticated: true
  })
}

function loadLoginMSSSOFail(state) {
  return updateObject(state, {
    error: FAILURE(LOGIN_MS_SSO),
    isLoading: false,
    authenticated: false
  })
}

function loadRegisterEnterprise(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function registerEnterpriseSuccess(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function registerEnterpriseFail(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function signUpVerifyToken(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function signUpVerifyTokenSuccess(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function signUpVerifyTokenFail(state) {
  return updateObject(state, {
    isLoading: false
  })
}

// Slice reducer
export default createReducer(initialState, {
  [REQUEST(REGISTER_GOOGLE_SSO)]: registerGoogleSSO,
  [SUCCESS(REGISTER_GOOGLE_SSO)]: registerGoogleSSOSuccess,
  [FAILURE(REGISTER_GOOGLE_SSO)]: registerGoogleSSOError,

  [REQUEST(REGISTER_BASIC)]: registerBasic,
  [SUCCESS(REGISTER_BASIC)]: registerBasicSuccess,
  [FAILURE(REGISTER_BASIC)]: registerBasicError,

  [REQUEST(REGISTER_BASIC_INVITE)]: registerBasicInvite,
  [SUCCESS(REGISTER_BASIC_INVITE)]: registerBasicInviteSuccess,
  [FAILURE(REGISTER_BASIC_INVITE)]: registerBasicInviteError,

  [REQUEST(PAYMENT_REGISTER)]: registerWithPayment,
  [SUCCESS(PAYMENT_REGISTER)]: registerWithPaymentSuccess,
  [FAILURE(PAYMENT_REGISTER)]: registerWithPaymentError,

  [REQUEST(REGISTER_RESEND_EMAIL)]: registerReSendEmail,
  [SUCCESS(REGISTER_RESEND_EMAIL)]: registerReSendEmailSuccess,
  [FAILURE(REGISTER_RESEND_EMAIL)]: registerReSendEmailError,

  [REQUEST(LOGIN)]: loadLogin,
  [SUCCESS(LOGIN)]: loginSuccess,
  [FAILURE(LOGIN)]: loginFail,
  [SUCCESS(SET_IS_2FA)]: setIs2FASuccess,

  [REQUEST(REGISTER_ENTERPRISE)]: loadRegisterEnterprise,
  [SUCCESS(REGISTER_ENTERPRISE)]: registerEnterpriseSuccess,
  [FAILURE(REGISTER_ENTERPRISE)]: registerEnterpriseFail,

  [REQUEST(LOGIN_GOOGLE_SSO)]: loadLoginGoogleSSO,
  [SUCCESS(LOGIN_GOOGLE_SSO)]: loadLoginGoogleSSOSuccess,
  [FAILURE(LOGIN_GOOGLE_SSO)]: loadLoginGoogleSSOFail,

  [REQUEST(LOGIN_MS_SSO)]: loadLoginMSSSO,
  [SUCCESS(LOGIN_MS_SSO)]: loadLoginMSSSOSuccess,
  [FAILURE(LOGIN_MS_SSO)]: loadLoginMSSSOFail,

  [REQUEST(SIGN_UP_VERIFY_TOKEN)]: signUpVerifyToken,
  [SUCCESS(SIGN_UP_VERIFY_TOKEN)]: signUpVerifyTokenSuccess,
  [FAILURE(SIGN_UP_VERIFY_TOKEN)]: signUpVerifyTokenFail,

  [REQUEST(LOGOUT)]: logOut
})
